import { Camera, Vector2, Vector3 } from "three";

export default function getPointFromVector (
  vector: Vector3,
  camera: Camera,
  canvasSize: { width: number,
    height: number, },
): Vector2 {
  const newVector = vector.clone();
  newVector.project(camera);

  return new Vector2(
    Math.round((newVector.x + 1) * canvasSize.width / 2),
    Math.round((-newVector.y + 1) * canvasSize.height / 2),
  );
}
